var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFavoriteFill = function SvgIconFavoriteFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1B",
    fillOpacity: 0.88,
    d: "m8 14-.97-.87a75 75 0 0 1-2.78-2.61c-.73-.74-1.32-1.4-1.75-1.98a6.3 6.3 0 0 1-.9-1.6 4.5 4.5 0 0 1-.27-1.5c0-1.05.35-1.92 1.05-2.62A3.85 3.85 0 0 1 8 3.17a3.95 3.95 0 0 1 3-1.4 3.57 3.57 0 0 1 3.67 3.66c0 .51-.09 1.01-.26 1.5a6.3 6.3 0 0 1-.91 1.61c-.43.59-1.02 1.24-1.75 1.98a77 77 0 0 1-2.78 2.61z"
  })));
};
export default SvgIconFavoriteFill;